export default "__VITE_ASSET__RjvteVtp__"